const BlogHero = () => {
  return (
    <section className="relative min-h-[60vh] md:min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9a68ee4bd2e273e1ede4385393671e53.jpg"
          alt="Roofing Knowledge & Tips"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 font-['Poppins'] leading-tight">
          Roofing Tips &amp; Insights
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto px-4">
          Expert advice, industry updates, and helpful guides for homeowners
        </p>
      </div>
    </section>
  );
};

export default BlogHero;
